/* eslint-disable max-statements */
import CreatedDocumentComponent from './created_document';
import CreateFolderModal from './modal/create_folder';
import CustomInput from '../reusable/input';
import EditFileComponent from './edit_file';
import EditFolderComponent from './edit_folder';
import { fetchClientsCustomerThunk } from '../../redux/thunks/customer';
import { fetchFoldersThunk } from '../../redux/thunks/folder';
import { gray } from '../../theme/themePrimitives';
import { Overlay } from '../prospecting';
import SelectedFolderComponent from './selected_folder';
import StartANewDocComponent from './start_a_doc';
import UploadFileModal from './modal/upload_file';
import { useParams } from 'react-router';
import { AddOutlined, CreateNewFolder, KeyboardArrowDown, Sort, UploadFile } from '@mui/icons-material';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, Menu, MenuItem, Typography } from '@mui/material';
import { fetchFilesThunk, fetchFolderFilesThunk, fetchSingleFileDetailsThunk, getWordDocumentThunk } from '../../redux/thunks/file';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const FilesComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const [search, setSearch] = useState<string>('');
    const [sort, setSort] = useState<boolean>(false);
    const [createFolder, setCreateFolder] = useState<boolean>(false);
    const [uploadFile, setUploadFile] = useState<boolean>(false);
    const [isCreated, setIsCreated] = useState<boolean>(false);
    const [anchorElForHeading, setAnchorElForHeading] = useState<null | HTMLElement>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [startingADoc, setStartingADoc] = useState<boolean>(false);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { selectedFolder, loaders: FolderLoader, selectedFolderForEdit } = useSelector((state: RootState) => state.folder);
    const { loaders, selectedFile } = useSelector((state: RootState) => state.file);

    useEffect(() => {
        const fetchAllLists = async () => {
            try {
                if (selectedFolder) {
                    await dispatch(fetchFolderFilesThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                } else {
                    await dispatch(fetchFoldersThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                    await dispatch(fetchFilesThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                    await dispatch(fetchClientsCustomerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                }
            } catch (e) {
                // Catch errors
            }
        };
        fetchAllLists();
    }, [dispatch, selectedFolder]);

    useEffect(() => {
        const fetchFileDetails = async () => {
            try {
                if (selectedFile) {
                    await dispatch(fetchSingleFileDetailsThunk()).unwrap();
                    if (selectedFile?.file_type === 'internal') {
                        await dispatch(getWordDocumentThunk()).unwrap();
                    }
                }
            } catch (e) {
                //
            }
        };
        if (selectedFile) {
            fetchFileDetails();
        }
    }, [selectedFile]);

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const startNewDocHandler = () => {
        handleMenuClose();
        setStartingADoc(true);
    };

    const headingChangeHandler = (value: boolean) => {
        setIsCreated(value);
        setAnchorElForHeading(null);
    };

    if (loaders.isLoading || FolderLoader.isLoading) {
        return (<Overlay>
            <CircularProgress size={24} />
            <Typography ml={2}>Loading...</Typography>
        </Overlay>);
    } else if (selectedFolderForEdit) {
        return <EditFolderComponent />;
    } else if (selectedFile) {
        return <EditFileComponent />;
    } else if (startingADoc) {
        return <StartANewDocComponent setStartingADoc={setStartingADoc} />;
    } else if (selectedFolder?.id) {
        return <SelectedFolderComponent />;
    }

    return (
        <Box borderTop={`1px solid ${gray[200]}`} py={2}>
            {currentUser?.role === 'client' && <Box display="none"><Button variant="text" color="secondary" sx={{
                fontSize: '1.5rem',
                fontWeight: 'bold'
            }} endIcon={<KeyboardArrowDown />} onClick={(e) => setAnchorElForHeading(e.currentTarget)}>
                {isCreated ? 'Created Documents' : 'Assigned Documents'}
            </Button>
                <Menu
                    anchorEl={anchorElForHeading}
                    open={Boolean(anchorElForHeading)}
                    onClose={() => setAnchorElForHeading(null)}
                    MenuListProps={{
                        'aria-labelledby': 'Heading-selection-button'
                    }}
                >
                    {!isCreated && <MenuItem onClick={() => headingChangeHandler(true)}>
                        Created Documents
                    </MenuItem>}
                    {isCreated && <MenuItem onClick={() => headingChangeHandler(false)}>
                        Assigned Documents
                    </MenuItem>}
                </Menu></Box>}
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" gap={1}>
                    <CustomInput
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search"
                    />
                    <Button variant="outlined" color={sort ? 'primary' : 'secondary'} startIcon={<Sort />} onClick={() => setSort(!sort)}>Sort</Button>
                </Box>
                {/* {(currentUser?.role === 'organizationOwner' || currentUser?.role === 'organizationAdmin' || currentUser?.role === 'companyManager') && <Box> */}
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleButtonClick}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px'
                        }}
                    >
                        + Add
                    </Button>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        MenuListProps={{
                            'aria-labelledby': 'add-pipeline-button'
                        }}
                    >
                        <MenuItem onClick={startNewDocHandler}>
                            <Box color={gray[500]} display="flex" alignItems="center" gap="10px"><AddOutlined color="disabled" />  Start a new doc</Box>
                        </MenuItem>
                        <MenuItem onClick={() => { setCreateFolder(true); setAnchorEl(null); }}>
                            <Box color={gray[500]} display="flex" alignItems="center" gap="10px"><CreateNewFolder color="disabled" /> Make a new folder</Box>
                        </MenuItem>
                        <MenuItem onClick={() => { setUploadFile(true); setAnchorEl(null); }}>
                            <Box color={gray[500]} display="flex" alignItems="center" gap="10px"><UploadFile color="disabled" /> Upload files</Box>
                        </MenuItem>
                    </Menu>
                </Box>
            </Box>
            <CreatedDocumentComponent
                isAssigned={currentUser?.role === 'organizationOwner' || currentUser?.role === 'organizationAdmin' || currentUser?.role === 'companyManager' ? false : !isCreated}
                setUploadFile={() => setUploadFile(true)}
                search={search}
                sort={sort}
            />
            {createFolder && <CreateFolderModal open={createFolder} onClose={() => { setCreateFolder(false); setAnchorEl(null); }} />}
            {uploadFile && <UploadFileModal open={uploadFile} onClose={() => { setUploadFile(false); setAnchorEl(null); }} />}
        </Box>
    );
};

export default FilesComponent;